export const hasRole = (role) => (me) => me.iamRoles.indexOf(role) !== -1;

export const hasAnyRole = (roles) => (me) => {
  const hasThisRole = (role) => hasRole(role)(me);
  return roles.some(hasThisRole);
};
